import {css} from 'lit'; export default css`.green-icon{--goto-icon-color:var(--goto-icon-color-success)}.yellow-icon{--goto-icon-color:var(--goto-icon-color-warning)}.red-icon{--goto-icon-color:var(--goto-icon-color-danger)}`;
    